const designerList = {
  title: 'More than 1000 designer brands | italist, ALWAYS LIKE A SALE',
  description:
    "Shop at italist: the largest selection of fashion luxury from Italy's finest boutiques, up to 40% cheaper. EXPRESS international shipping!",
};

export default designerList;
